import React from 'react'
import Header from '../component/Header'
import Keyfeature from '../component/Keyfeature';
import Testimonial from '../component/Testimonial';
import Achivment from '../component/Achivment';
import HeroBanner from '../component/HeroBanner';
import Intro from '../component/Intro';
import HomeService from '../component/HomeService';
import Footer from '../component/Footer';
// import CustomerList from '../component/CustomerList';
import Faq from '../component/Faq';
import CustomerList from '../component/CustomerList';
import ProductType from '../component/ProductType';


export default function Home() {
    return (
        <>
            <Header />
            <HeroBanner />
            <Intro />
            <ProductType />
            {/* <HomeService /> */}

            <Keyfeature />
            <Achivment />

            {/* <Testimonial/> */}
            <CustomerList />
            <Faq />


            <Footer />

        </>
    )
}
